import { render, staticRenderFns } from "./SimpleRequisiteDataSelectDisplay.vue?vue&type=template&id=8ae80b22&scoped=true&"
import script from "./SimpleRequisiteDataSelectDisplay.vue?vue&type=script&lang=js&"
export * from "./SimpleRequisiteDataSelectDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SimpleRequisiteDataSelectDisplay.vue?vue&type=style&index=0&id=8ae80b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae80b22",
  null
  
)

export default component.exports